// lib/components/search-panel/search-panel/action-type.ts
var ActionType = {
  Reset: 1,
  UpdateValue: 11,
  UpdateItem: 12,
  FavoriteLoaded: 21,
  FavoriteSet: 22
};

export {
  ActionType
};
